(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    if (new URLSearchParams(window.location.search).get("mode") === "view") return;
    var root = document.querySelector("[data-cp-designer]");
    if (!root) return;

    var CP = window.CustomPoster;
    CP.loadGoogleFonts();

    var backgrounds = JSON.parse(root.getAttribute("data-backgrounds") || "[]");
    var shapes = JSON.parse(root.getAttribute("data-shapes") || "[]");
    var productHandle = root.getAttribute("data-product-handle");
    var viewPageUrl = root.getAttribute("data-view-page-url");

    var canvas = root.querySelector("[data-cp-canvas]");
    var ctx = canvas.getContext("2d");
    canvas.width = CP.CANVAS_W;
    canvas.height = CP.CANVAS_H;

    var bgList = root.querySelector("[data-cp-bg-list]");
    var bgColorField = root.querySelector("[data-cp-bg-color-field]");
    var bgColorRoleList = root.querySelector("[data-cp-bg-color-roles]");
    var bgColorList = root.querySelector("[data-cp-bg-color-list]");
    var bgColorCustom = root.querySelector("[data-cp-bg-color-custom]");
    var shapeList = root.querySelector("[data-cp-shape-list]");
    var shapeToggleBtn = root.querySelector("[data-cp-toggle-shapes]");
    var shapePicker = root.querySelector("[data-cp-shape-picker]");
    var layerList = root.querySelector("[data-cp-layer-list]");
    var addLayerBtn = root.querySelector("[data-cp-add-layer]");
    var textField = root.querySelector("[data-cp-text-field]");
    var textInput = root.querySelector("[data-cp-text]");
    var symbolList = root.querySelector("[data-cp-symbol-list]");
    var fontField = root.querySelector("[data-cp-font-field]");
    var fontSelect = root.querySelector("[data-cp-font]");
    var styleField = root.querySelector("[data-cp-style-field]");
    var weightList = root.querySelector("[data-cp-weight-list]");
    var italicBtn = root.querySelector("[data-cp-italic]");
    var editingTitle = root.querySelector("[data-cp-editing-title]");
    var colorLabel = root.querySelector("[data-cp-color-label]");
    var colorDesc = root.querySelector("[data-cp-color-desc]");
    var colorRoleList = root.querySelector("[data-cp-color-roles]");
    var colorList = root.querySelector("[data-cp-color-list]");
    var colorCustom = root.querySelector("[data-cp-color-custom]");
    var paspartuToggle = root.querySelector("[data-cp-paspartu]");
    var sizeSelect = root.querySelector("[data-cp-size]");
    var previewRatio = root.querySelector("[data-cp-preview-ratio]");
    var rotateBtn = root.querySelector("[data-cp-rotate]");
    var presetList = root.querySelector("[data-cp-preset-list]");
    var addBtn = root.querySelector("[data-cp-add]");
    var statusEl = root.querySelector("[data-cp-status]");

    var PRESET_DEFINITIONS = [
      {
        name: "İyi Şeyler",
        bg: "Lila Dalga",
        layers: [
          { type: "text", text: "İYİ ŞEYLER\nYOLDA", font: "bebas", color: "#1E2638", x: 0.5, y: 0.5, scale: 1.35 }
        ]
      },
      {
        name: "Güzel Köşe",
        bg: "Mavi Çiçek",
        layers: [
          { type: "text", text: "EVİN\nEN GÜZEL\nKÖŞESİ", font: "poppins", color: "#1E2638", x: 0.5, y: 0.52, scale: 0.95 }
        ]
      },
      {
        name: "Mutluluk",
        bg: "Puantiye",
        layers: [
          { type: "shape", shape: "Flower", colors: { outer: "#1E2638", middle: "#F57AB5", fill: "#F6E79B" }, x: 0.5, y: 0.28, scale: 0.72 },
          { type: "text", text: "MUTLULUK\nBURADA", font: "caveat", color: "#1E2638", x: 0.5, y: 0.68, scale: 1.2 }
        ]
      },
      {
        name: "More Amor",
        bg: "Zebra Dalga",
        bgColors: { background: "#E9DEC8", pattern: "#C6669F" },
        layers: [
          { type: "shape", shape: "More Amor Kemer", colors: { outer: "#C6669F", middle: "#7652A3", fill: "#E9DEC8" }, x: 0.475, y: 0.45, scale: 2.05 },
          { type: "text", text: "MORE", font: "luckiest", weight: "thin", color: "#E3429D", x: 0.485, y: 0.33, scale: 1.72 },
          { type: "text", text: "AMOR", font: "luckiest", weight: "thin", color: "#E3429D", x: 0.485, y: 0.42, scale: 1.72 },
          { type: "text", text: "POR", font: "luckiest", weight: "thin", color: "#E3429D", x: 0.39, y: 0.515, scale: 1.72 },
          { type: "text", text: "♥", font: "poppins", color: "#FF1B0B", x: 0.59, y: 0.52, scale: 1.05 },
          { type: "text", text: "FAVOR", font: "luckiest", weight: "thin", color: "#A33575", x: 0.475, y: 0.61, scale: 1.7 }
        ]
      },
      {
        name: "Love Lives Here",
        bg: "Candy Gradyan",
        layers: [
          { type: "text", text: "LOVE LIVES\nHERE", font: "playfair", color: "#1A1A1A", x: 0.5, y: 0.3, scale: 1.05 },
          { type: "shape", shape: "Wobbly Oval", colors: { outer: "#1A1A1A", middle: "#FFFFFF", fill: "#F8D8E5" }, x: 0.5, y: 0.68, scale: 0.78 }
        ]
      },
      {
        name: "Slay",
        bg: "Düz Renk",
        bgColors: { background: "#C56A9E" },
        layers: [
          { type: "text", text: "SLAY", font: "anton", color: "#F28CC6", x: 0.5, y: 0.5, scale: 6.25, rotation: 90 }
        ]
      }
    ];

    var state = CP.defaultState();
    var activeLayerId = state.layers[0].id;
    var activeColorRole = "color"; // metin icin sabit; sekil icin 'outer'|'middle'|'fill'
    var activeBgColorRole = "";
    var bgImage = null;
    var bgImageCache = {};
    var shapeImageCache = {};
    var product = null;

    function applyPosterSize(sizeLabel) {
      var dimensions = CP.canvasDimensionsForSize(sizeLabel);
      canvas.width = dimensions.width;
      canvas.height = dimensions.height;
      canvas.style.aspectRatio = dimensions.width + " / " + dimensions.height;
      if (previewRatio) previewRatio.textContent = dimensions.label;
      render();
    }

    function activeLayer() {
      var layer = state.layers.filter(function (l) { return l.id === activeLayerId; })[0];
      return layer || state.layers[0];
    }

    function setStatus(msg, isError) {
      if (!statusEl) return;
      statusEl.textContent = msg || "";
      statusEl.style.color = isError ? "#c0392b" : "";
    }

    function ensureShapeImagesLoaded() {
      state.layers
        .filter(function (l) { return l.type === "shape" && l.shapeUrl; })
        .forEach(function (l) {
          var key = CP.shapeImageKey(l);
          if (shapeImageCache[key]) return;
          CP.loadTintedShapeImage(l).then(function (img) {
            shapeImageCache[key] = img;
            render();
          }).catch(function (err) {
            console.error("[cp] shape tint failed", key, err);
          });
        });
    }

    // Canvas'in IC cozunurlugu (1000x1500) ekranda gosterilen boyutundan cok daha buyuk.
    // Telefonda canvas ~320px genisliginde cizildiginde olcek ~3.1x oluyor; bu yuzden
    // canvas pikseliyle yazilmis sabit boyutlar (tutamac yaricapi vb.) ekranda kucuciik
    // kaliyordu (~18px dokunma hedefi; WCAG 2.2 asgarisi 24px, onerilen 44px).
    // Cozum: tum dokunma/cizim olculerini EKRAN pikseli cinsinden tanimlayip canvas
    // olcegiyle carpmak. Boylece hem masaustunde hem mobilde ayni fiziksel buyuklukte olur.
    function canvasScale() {
      var rect = canvas.getBoundingClientRect();
      return rect.width > 0 ? canvas.width / rect.width : 1;
    }
    function px(cssPx) {
      return cssPx * canvasScale();
    }

    // Ekran pikseli cinsinden hedef olculer
    var HANDLE_VISUAL_R = 15; // gorunen daire yaricapi  -> ~30px capinda
    var HANDLE_HIT_R = 24;    // dokunma isabet yaricapi -> ~48px capinda (44px onerisinin ustunde)
    var BOX_PAD = 8;          // katman kutusu kenar toleransi

    function rotatedBoxPoint(box, localX, localY) {
      var rad = ((Number(box.rotation) || 0) * Math.PI) / 180;
      var cos = Math.cos(rad);
      var sin = Math.sin(rad);
      return {
        x: box.cx + localX * cos - localY * sin,
        y: box.cy + localX * sin + localY * cos
      };
    }

    // Tutamaclar katman kutusunun kosesinde durur. Buyutme sinirsiz oldugu icin kutu
    // tuvalden tasabilir; tasan durumda tutamac ekran disinda kalirsa kullanici sekli
    // BIR DAHA KUCULTEMEZ (geri alma yolu yalniz katmani silmek olurdu). Bu yuzden
    // tutamaclarin konumu tuvalin icine sikistiriliyor: buyutme serbest ama her zaman
    // geri alinabilir. Sikistirma yalniz tutamacin CIZILDIGI/yakalandigi yeri etkiler;
    // olcek hesabi (onPointerMove) kutunun gercek merkezine gore yapildigi icin degismez.
    function clampToCanvas(point) {
      var kenar = px(28);
      return {
        x: Math.min(canvas.width - kenar, Math.max(kenar, point.x)),
        y: Math.min(canvas.height - kenar, Math.max(kenar, point.y))
      };
    }

    function selectionHandles(box) {
      var offset = px(12);
      return {
        resize: clampToCanvas(rotatedBoxPoint(box, box.w / 2 + offset, box.h / 2 + offset)),
        rotate: clampToCanvas(rotatedBoxPoint(box, box.w / 2 + offset, -box.h / 2 - offset))
      };
    }

    function positionRotateButton(box) {
      if (!rotateBtn) return;
      if (!box) {
        rotateBtn.hidden = true;
        return;
      }
      var point = selectionHandles(box).rotate;
      var canvasRect = canvas.getBoundingClientRect();
      var boxRect = canvas.parentElement.getBoundingClientRect();
      var left = canvasRect.left - boxRect.left + (point.x / canvas.width) * canvasRect.width;
      var top = canvasRect.top - boxRect.top + (point.y / canvas.height) * canvasRect.height;
      left = Math.max(24, Math.min(boxRect.width - 24, left));
      top = Math.max(22, Math.min(boxRect.height - 22, top));
      rotateBtn.style.left = left + "px";
      rotateBtn.style.top = top + "px";
      rotateBtn.hidden = false;
    }

    function drawSelectionUI(box) {
      if (!box) return;
      var s = canvasScale();
      var handleR = HANDLE_VISUAL_R * s;
      var glyph = handleR * 0.42;
      var handles = selectionHandles(box);
      var rotationRad = ((Number(box.rotation) || 0) * Math.PI) / 180;

      ctx.save();
      ctx.translate(box.cx, box.cy);
      ctx.rotate(rotationRad);
      ctx.strokeStyle = "#1a1a1a";
      ctx.lineWidth = 1.5 * s;
      ctx.setLineDash([6 * s, 4 * s]);
      var pad = BOX_PAD * s;
      ctx.strokeRect(-box.w / 2 - pad, -box.h / 2 - pad, box.w + pad * 2, box.h + pad * 2);
      ctx.setLineDash([]);
      ctx.restore();

      // Sag-alt kosedeki BUYUTME TUTAMACI - artik ekran olceginde sabit buyuklukte.
      ctx.save();
      ctx.beginPath();
      ctx.arc(handles.resize.x, handles.resize.y, handleR, 0, Math.PI * 2);
      ctx.fillStyle = "#ffffff";
      ctx.fill();
      ctx.lineWidth = 2 * s;
      ctx.strokeStyle = "#1a1a1a";
      ctx.stroke();

      ctx.strokeStyle = "#1a1a1a";
      ctx.lineWidth = 2 * s;
      ctx.lineCap = "round";
      ctx.beginPath();
      ctx.moveTo(handles.resize.x - glyph, handles.resize.y + glyph);
      ctx.lineTo(handles.resize.x + glyph, handles.resize.y - glyph);
      ctx.moveTo(handles.resize.x + glyph, handles.resize.y - glyph);
      ctx.lineTo(handles.resize.x + glyph * 0.15, handles.resize.y - glyph);
      ctx.moveTo(handles.resize.x + glyph, handles.resize.y - glyph);
      ctx.lineTo(handles.resize.x + glyph, handles.resize.y - glyph * 0.15);
      ctx.moveTo(handles.resize.x - glyph, handles.resize.y + glyph);
      ctx.lineTo(handles.resize.x - glyph * 0.15, handles.resize.y + glyph);
      ctx.moveTo(handles.resize.x - glyph, handles.resize.y + glyph);
      ctx.lineTo(handles.resize.x - glyph, handles.resize.y + glyph * 0.15);
      ctx.stroke();
      ctx.restore();
    }

    function render() {
      var result = CP.drawComposition(ctx, canvas.width, canvas.height, state, bgImage, shapeImageCache);
      root._cpLayerBoxes = result.layerBoxes;
      var activeBox = result.layerBoxes.filter(function (b) { return b.id === activeLayerId; })[0];
      drawSelectionUI(activeBox);
      positionRotateButton(activeBox);
    }

    function findBackground(label) {
      return backgrounds.filter(function (bg) { return bg.label === label; })[0] || backgrounds[0] || null;
    }

    function findShape(label) {
      return shapes.filter(function (shape) { return shape.label === label; })[0] || null;
    }

    function buildPresetState(definition) {
      var next = CP.defaultState();
      var bg = findBackground(definition.bg);
      if (bg) {
        next.bg = bg.url;
        next.bgLabel = bg.label;
        next.bgParts = bg.parts ? bg.parts.slice() : [];
        next.bgColors = Object.assign({}, bg.defaultColors || {}, definition.bgColors || {});
      }
      next.layers = definition.layers.map(function (layerDef) {
        if (layerDef.type === "shape") {
          var shape = findShape(layerDef.shape);
          return CP.defaultShapeLayer({
            shapeUrl: shape ? shape.url : "",
            shapeLabel: shape ? shape.label : layerDef.shape,
            parts: shape && shape.parts ? shape.parts.slice() : ["outer", "middle", "fill"],
            colors: Object.assign({}, layerDef.colors || {}),
            x: layerDef.x,
            y: layerDef.y,
            scale: layerDef.scale,
            rotation: layerDef.rotation || 0
          });
        }
        return CP.defaultLayer({
          text: layerDef.text,
          font: layerDef.font,
          weight: layerDef.weight || "bold",
          italic: !!layerDef.italic,
          color: layerDef.color,
          x: layerDef.x,
          y: layerDef.y,
          scale: layerDef.scale,
          rotation: layerDef.rotation || 0
        });
      });
      return next;
    }

    function loadPresetMedia(presetState) {
      var bgPromise = presetState.bgParts && presetState.bgParts.length
        ? CP.loadTintedBackgroundImage({ url: presetState.bg, parts: presetState.bgParts }, presetState.bgColors)
        : CP.loadImage(presetState.bg);
      var presetShapeImages = {};
      var shapePromises = presetState.layers
        .filter(function (layer) { return layer.type === "shape" && layer.shapeUrl; })
        .map(function (layer) {
          return CP.loadTintedShapeImage(layer).then(function (img) {
            presetShapeImages[CP.shapeImageKey(layer)] = img;
          });
        });
      return Promise.all([bgPromise].concat(shapePromises)).then(function (results) {
        return { bgImage: results[0], shapeImages: presetShapeImages };
      });
    }

    function applyPreset(definition, card) {
      var selectedSize = state.size;
      state = buildPresetState(definition);
      state.size = selectedSize;
      activeLayerId = state.layers[0].id;
      activeColorRole = state.layers[0].type === "shape" ? state.layers[0].parts[0] : "color";
      activeBgColorRole = state.bgParts[0] || "";
      bgImage = null;
      paspartuToggle.checked = false;
      root.querySelectorAll("[data-cp-bg-item]").forEach(function (item) {
        item.classList.toggle("is-selected", item.getAttribute("data-url") === state.bg);
      });
      if (presetList) {
        presetList.querySelectorAll(".cp-preset-card").forEach(function (item) {
          item.classList.toggle("is-selected", item === card);
          item.setAttribute("aria-pressed", item === card ? "true" : "false");
        });
      }
      renderBgColorRoles();
      ensureBackgroundImageLoaded();
      ensureShapeImagesLoaded();
      syncFormToActiveLayer();
      renderLayerList();
      render();
    }

    function renderPresetCards() {
      if (!presetList) return;
      presetList.innerHTML = "";
      PRESET_DEFINITIONS.forEach(function (definition) {
        var card = document.createElement("button");
        card.type = "button";
        card.className = "cp-preset-card";
        card.setAttribute("aria-label", definition.name + " örnek tasarımını uygula");
        card.setAttribute("aria-pressed", "false");

        var thumbnail = document.createElement("canvas");
        thumbnail.width = 240;
        thumbnail.height = 360;
        thumbnail.setAttribute("aria-hidden", "true");
        card.appendChild(thumbnail);

        var label = document.createElement("span");
        label.textContent = definition.name;
        card.appendChild(label);

        card.addEventListener("click", function () {
          applyPreset(definition, card);
        });
        presetList.appendChild(card);

        var thumbnailState = buildPresetState(definition);
        loadPresetMedia(thumbnailState).then(function (media) {
          var thumbCtx = thumbnail.getContext("2d");
          CP.drawComposition(thumbCtx, thumbnail.width, thumbnail.height, thumbnailState, media.bgImage, media.shapeImages, { showPlaceholders: false });
        }).catch(function (err) {
          console.error("[cp] preset thumbnail failed", definition.name, err);
        });
      });
    }

    if (rotateBtn) {
      rotateBtn.addEventListener("click", function () {
        var layer = activeLayer();
        if (!layer) return;
        layer.rotation = ((Number(layer.rotation) || 0) + 90) % 360;
        render();
      });
    }

    window.addEventListener("resize", function () {
      var boxes = root._cpLayerBoxes || [];
      var activeBox = boxes.filter(function (b) { return b.id === activeLayerId; })[0];
      positionRotateButton(activeBox);
    });

    function layerChipLabel(layer, idx) {
      if (layer.type === "shape") return "◆ " + (layer.shapeLabel || "Şekil " + (idx + 1));
      return layer.text && layer.text.trim() ? layer.text.slice(0, 16) : "Metin " + (idx + 1);
    }

    function moveLayer(layerId, dir) {
      var idx = state.layers.findIndex(function (l) { return l.id === layerId; });
      var newIdx = idx + dir;
      if (idx < 0 || newIdx < 0 || newIdx >= state.layers.length) return;
      var tmp = state.layers[idx];
      state.layers[idx] = state.layers[newIdx];
      state.layers[newIdx] = tmp;
      renderLayerList();
      render();
    }

    function renderLayerList() {
      layerList.innerHTML = "";
      state.layers.forEach(function (layer, idx) {
        var chip = document.createElement("div");
        chip.className = "cp-layer-chip" + (layer.id === activeLayerId ? " is-active" : "");

        var order = document.createElement("div");
        order.className = "cp-layer-chip-order";

        var upBtn = document.createElement("button");
        upBtn.type = "button";
        upBtn.textContent = "▲";
        upBtn.title = "Öne getir (üstüne çıkar)";
        upBtn.disabled = idx === state.layers.length - 1;
        upBtn.addEventListener("click", function (evt) {
          evt.stopPropagation();
          moveLayer(layer.id, 1);
        });
        order.appendChild(upBtn);

        var downBtn = document.createElement("button");
        downBtn.type = "button";
        downBtn.textContent = "▼";
        downBtn.title = "Arkaya gönder (altına al)";
        downBtn.disabled = idx === 0;
        downBtn.addEventListener("click", function (evt) {
          evt.stopPropagation();
          moveLayer(layer.id, -1);
        });
        order.appendChild(downBtn);

        chip.appendChild(order);

        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cp-layer-chip-select";
        btn.textContent = layerChipLabel(layer, idx);
        btn.addEventListener("click", function () {
          activeLayerId = layer.id;
          syncFormToActiveLayer();
          renderLayerList();
        });
        chip.appendChild(btn);

        if (state.layers.length > 1) {
          var del = document.createElement("button");
          del.type = "button";
          del.className = "cp-layer-chip-remove";
          del.textContent = "×";
          del.title = "Bu katmanı sil";
          del.addEventListener("click", function (evt) {
            evt.stopPropagation();
            state.layers = state.layers.filter(function (l) { return l.id !== layer.id; });
            if (activeLayerId === layer.id) activeLayerId = state.layers[0].id;
            syncFormToActiveLayer();
            renderLayerList();
            render();
          });
          chip.appendChild(del);
        }

        layerList.appendChild(chip);
      });
    }

    function currentColorValue() {
      var layer = activeLayer();
      if (layer.type === "shape") return layer.colors[activeColorRole] || "";
      return layer.color;
    }

    function setCurrentColorValue(c) {
      var layer = activeLayer();
      if (layer.type === "shape") {
        layer.colors[activeColorRole] = c;
        ensureShapeImagesLoaded();
      } else {
        layer.color = c;
      }
    }

    function renderColorRoles() {
      var layer = activeLayer();
      colorRoleList.innerHTML = "";
      if (layer.type !== "shape") {
        colorRoleList.style.display = "none";
        // Metin katmani secilikken kullaniciya "bu YAZININ rengi" oldugunu acikca soyle
        if (colorLabel) colorLabel.textContent = "Yazı rengi";
        if (colorDesc) colorDesc.textContent = "Yukarıda yazdığın yazının rengini belirler.";
        if (editingTitle) editingTitle.textContent = "Şu an düzenlediğin: yazı";
        return;
      }
      colorRoleList.style.display = "";
      if (colorLabel) colorLabel.textContent = "Şeklin renkleri";
      if (colorDesc) colorDesc.textContent = "Önce şeklin hangi kısmını boyayacağını seç, sonra rengine tıkla.";
      if (editingTitle) editingTitle.textContent = "Şu an düzenlediğin: şekil — " + (layer.shapeLabel || "şekil");
      if (layer.parts.indexOf(activeColorRole) === -1) activeColorRole = layer.parts[0];
      layer.parts.forEach(function (part) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cp-role-btn" + (part === activeColorRole ? " is-selected" : "");
        btn.textContent = CP.SHAPE_ROLE_LABELS[part] || part;
        btn.addEventListener("click", function () {
          activeColorRole = part;
          renderColorRoles();
          syncColorGridSelection();
        });
        colorRoleList.appendChild(btn);
      });
    }

    function syncColorGridSelection() {
      var c = currentColorValue();
      colorCustom.value = c || "#000000";
      root.querySelectorAll("[data-color]").forEach(function (el) {
        el.classList.toggle("is-selected", el.getAttribute("data-color") === c);
      });
    }

    function syncFormToActiveLayer() {
      var layer = activeLayer();
      var isText = layer.type !== "shape";
      textField.style.display = isText ? "" : "none";
      fontField.style.display = isText ? "" : "none";
      styleField.style.display = isText ? "" : "none";

      if (isText) {
        activeColorRole = "color";
        textInput.value = layer.text;
        fontSelect.value = layer.font;
        italicBtn.classList.toggle("is-selected", !!layer.italic);
        root.querySelectorAll("[data-weight]").forEach(function (el) {
          el.classList.toggle("is-selected", el.getAttribute("data-weight") === layer.weight);
        });
      } else if (layer.parts.indexOf(activeColorRole) === -1) {
        activeColorRole = layer.parts[0];
      }
      renderColorRoles();
      syncColorGridSelection();
    }

    addLayerBtn.addEventListener("click", function () {
      var newLayer = CP.defaultLayer({
        text: "Yeni yazı",
        y: Math.min(0.85, activeLayer().y + 0.18)
      });
      state.layers.push(newLayer);
      activeLayerId = newLayer.id;
      syncFormToActiveLayer();
      renderLayerList();
      render();
      if (shapeToggleBtn && shapePicker) {
        shapePicker.hidden = true;
        shapeToggleBtn.setAttribute("aria-expanded", "false");
        shapeToggleBtn.classList.remove("is-open");
      }
      window.setTimeout(function () {
        textInput.scrollIntoView({ behavior: "smooth", block: "center" });
        textInput.focus({ preventScroll: true });
        textInput.select();
      }, 0);
    });

    if (shapeToggleBtn && shapePicker) {
      shapeToggleBtn.addEventListener("click", function () {
        var willOpen = shapePicker.hidden;
        shapePicker.hidden = !willOpen;
        shapeToggleBtn.setAttribute("aria-expanded", String(willOpen));
        shapeToggleBtn.classList.toggle("is-open", willOpen);
      });
    }

    function ensureBackgroundImageLoaded() {
      var bg = { url: state.bg, parts: state.bgParts };
      var key = CP.bgImageKey(bg, state.bgColors);
      if (bgImageCache[key]) {
        bgImage = bgImageCache[key];
        render();
        return;
      }
      var loader = state.bgParts && state.bgParts.length
        ? CP.loadTintedBackgroundImage(bg, state.bgColors)
        : CP.loadImage(state.bg);
      loader.then(function (img) {
        bgImageCache[key] = img;
        if (state.bg === bg.url) {
          bgImage = img;
          render();
        }
      }).catch(function (err) {
        console.error("[cp] background load failed", err);
      });
    }

    function renderBgColorRoles() {
      bgColorRoleList.innerHTML = "";
      if (!state.bgParts || !state.bgParts.length) {
        bgColorField.style.display = "none";
        return;
      }
      bgColorField.style.display = "";
      if (state.bgParts.indexOf(activeBgColorRole) === -1) activeBgColorRole = state.bgParts[0];
      state.bgParts.forEach(function (part) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cp-role-btn" + (part === activeBgColorRole ? " is-selected" : "");
        btn.textContent = CP.bgRoleLabel(part);
        btn.addEventListener("click", function () {
          activeBgColorRole = part;
          renderBgColorRoles();
          syncBgColorGridSelection();
        });
        bgColorRoleList.appendChild(btn);
      });
      syncBgColorGridSelection();
    }

    function syncBgColorGridSelection() {
      var c = (state.bgColors || {})[activeBgColorRole] || "";
      bgColorCustom.value = c || "#000000";
      bgColorList.querySelectorAll("[data-color]").forEach(function (el) {
        el.classList.toggle("is-selected", el.getAttribute("data-color") === c);
      });
    }

    function setBackground(bg) {
      state.bg = bg.url;
      state.bgLabel = bg.label;
      state.bgParts = bg.parts ? bg.parts.slice() : [];
      state.bgColors = bg.parts ? Object.assign({}, bg.defaultColors) : {};
      root.querySelectorAll("[data-cp-bg-item]").forEach(function (el) {
        el.classList.toggle("is-selected", el.getAttribute("data-url") === bg.url);
      });
      renderBgColorRoles();
      ensureBackgroundImageLoaded();
    }

    // Arka plan galerisi
    backgrounds.forEach(function (bg, idx) {
      var item = document.createElement("button");
      item.type = "button";
      item.className = "cp-bg-item";
      item.setAttribute("data-cp-bg-item", "");
      item.setAttribute("data-url", bg.url);
      item.style.backgroundImage = "url('" + bg.url + "')";
      item.title = bg.label;
      item.addEventListener("click", function () {
        setBackground(bg);
      });
      bgList.appendChild(item);
      if (idx === 0) setBackground(bg);
    });

    // ---- ORTAK RENK PALETI ----
    // Kullanici "kendi rengini sec" ile bir renk sectiginde o renk hatirlanir ve HER IKI
    // palette de (yazi/sekil + arka plan) en basa eklenir; boylece ayni rengi tasarimin her
    // yerinde tekrar tekrar secmek zorunda kalmaz. Sayfa yenilenince liste sifirlanir.
    var ozelRenkler = [];
    var OZEL_RENK_SINIRI = 12;

    function renkAnahtari(c) {
      return String(c || "").trim().toLowerCase();
    }

    function ozelRenkEkle(c) {
      var h = renkAnahtari(c);
      if (!h) return;
      // Hazir palette zaten varsa listeyi sisirmeye gerek yok
      var hazirVar = CP.COLORS.some(function (x) { return renkAnahtari(x) === h; });
      if (hazirVar) return;
      ozelRenkler = ozelRenkler.filter(function (x) { return renkAnahtari(x) !== h; });
      ozelRenkler.unshift(h);
      if (ozelRenkler.length > OZEL_RENK_SINIRI) ozelRenkler.length = OZEL_RENK_SINIRI;
      paletleriYenile();
    }

    function paletDoldur(kapsayici, secildiginde) {
      if (!kapsayici) return;
      kapsayici.textContent = "";
      var tumu = ozelRenkler.concat(CP.COLORS);
      tumu.forEach(function (c, i) {
        var ozelMi = i < ozelRenkler.length;
        var sw = document.createElement("button");
        sw.type = "button";
        sw.className = "cp-color-swatch" + (ozelMi ? " cp-color-swatch--ozel" : "");
        sw.style.background = c;
        sw.setAttribute("data-color", c);
        sw.title = ozelMi ? c + " (senin seçtiğin renk)" : c;
        sw.addEventListener("click", function () { secildiginde(c); });
        kapsayici.appendChild(sw);
      });
    }

    function paletleriYenile() {
      paletDoldur(colorList, function (c) {
        setCurrentColorValue(c);
        syncColorGridSelection();
        render();
      });
      paletDoldur(bgColorList, function (c) {
        state.bgColors[activeBgColorRole] = c;
        syncBgColorGridSelection();
        ensureBackgroundImageLoaded();
      });
      syncColorGridSelection();
      syncBgColorGridSelection();
    }

    bgColorCustom.addEventListener("input", function () {
      state.bgColors[activeBgColorRole] = bgColorCustom.value;
      bgColorList.querySelectorAll("[data-color]").forEach(function (el) {
        el.classList.remove("is-selected");
      });
      ensureBackgroundImageLoaded();
    });
    // 'change' renk secici KAPANINCA bir kez tetiklenir. 'input' surukleme boyunca onlarca kez
    // tetiklendigi icin hatirlanan listeye ancak burada eklemek dogru - yoksa palet ara tonlarla dolar.
    bgColorCustom.addEventListener("change", function () {
      ozelRenkEkle(bgColorCustom.value);
    });

    // Sekil galerisi - tiklaninca YENI bir sekil katmani ekler
    shapes.forEach(function (shape) {
      var item = document.createElement("button");
      item.type = "button";
      item.className = "cp-shape-item";
      var img = document.createElement("img");
      img.src = shape.url;
      img.alt = shape.label;
      item.appendChild(img);
      item.title = shape.label;
      item.addEventListener("click", function () {
        // Sekil listesinde "defaultColors" varsa (bkz. liquid: ince cizgi ailesi siyah baslar)
        // genel varsayilanin uzerine yazilir - arka planlardaki bg.defaultColors ile ayni mantik.
        var newLayer = CP.defaultShapeLayer({
          shapeUrl: shape.url,
          shapeLabel: shape.label,
          parts: shape.parts,
          colors: Object.assign({}, CP.DEFAULT_SHAPE_COLORS, shape.defaultColors || {}),
          y: Math.min(0.85, activeLayer().y)
        });
        state.layers.push(newLayer);
        activeLayerId = newLayer.id;
        ensureShapeImagesLoaded();
        syncFormToActiveLayer();
        renderLayerList();
        render();
        if (shapeToggleBtn && shapePicker) {
          shapePicker.hidden = true;
          shapeToggleBtn.setAttribute("aria-expanded", "false");
          shapeToggleBtn.classList.remove("is-open");
        }
      });
      shapeList.appendChild(item);
    });

    // Font secimi
    CP.FONTS.forEach(function (f) {
      var opt = document.createElement("option");
      opt.value = f.id;
      opt.textContent = f.label;
      opt.style.fontFamily = f.css;
      fontSelect.appendChild(opt);
    });
    fontSelect.addEventListener("change", function () {
      activeLayer().font = fontSelect.value;
      render();
    });

    // Kalinlik (ince/kalin)
    CP.WEIGHTS.forEach(function (w) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cp-weight-btn";
      btn.textContent = w.label;
      btn.setAttribute("data-weight", w.id);
      btn.style.fontWeight = w.css;
      btn.addEventListener("click", function () {
        activeLayer().weight = w.id;
        root.querySelectorAll("[data-weight]").forEach(function (el) {
          el.classList.toggle("is-selected", el.getAttribute("data-weight") === w.id);
        });
        render();
      });
      weightList.appendChild(btn);
    });

    // Italik
    italicBtn.addEventListener("click", function () {
      var layer = activeLayer();
      layer.italic = !layer.italic;
      italicBtn.classList.toggle("is-selected", !!layer.italic);
      render();
    });

    // Renk secimi - iki palet de paletleriYenile() tarafindan doldurulur (ozel renkler en basta)
    paletleriYenile();

    colorCustom.addEventListener("input", function () {
      setCurrentColorValue(colorCustom.value);
      root.querySelectorAll("[data-color]").forEach(function (el) {
        el.classList.remove("is-selected");
      });
      render();
    });
    colorCustom.addEventListener("change", function () {
      ozelRenkEkle(colorCustom.value);
    });

    // Yazi
    textInput.addEventListener("input", function () {
      activeLayer().text = textInput.value;
      renderLayerList();
      render();
    });

    // Klavyede olmayan semboller (kalp, yildiz vb.) - imlecin oldugu yere eklenir
    CP.SYMBOLS.forEach(function (sym) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cp-symbol-btn";
      btn.textContent = sym;
      btn.title = "Ekle: " + sym;
      // mousedown'da preventDefault, textarea'nin odagini/imlec konumunu kaybetmesini engeller
      btn.addEventListener("mousedown", function (evt) {
        evt.preventDefault();
      });
      btn.addEventListener("click", function () {
        var start = textInput.selectionStart != null ? textInput.selectionStart : textInput.value.length;
        var end = textInput.selectionEnd != null ? textInput.selectionEnd : textInput.value.length;
        var val = textInput.value;
        var next = val.slice(0, start) + sym + val.slice(end);
        textInput.value = next;
        var newPos = start + sym.length;
        textInput.focus();
        textInput.setSelectionRange(newPos, newPos);
        activeLayer().text = next;
        renderLayerList();
        render();
      });
      symbolList.appendChild(btn);
    });

    // Paspartu
    paspartuToggle.addEventListener("change", function () {
      state.paspartu = paspartuToggle.checked;
      render();
    });

    // Boyut/varyant
    function loadProduct() {
      if (!productHandle) return;
      fetch("/products/" + productHandle + ".js")
        .then(function (r) {
          if (!r.ok) throw new Error("urun bulunamadi");
          return r.json();
        })
        .then(function (p) {
          product = p;
          sizeSelect.innerHTML = "";
          p.variants.forEach(function (v, idx) {
            var opt = document.createElement("option");
            opt.value = v.id;
            opt.textContent = v.title + " - " + (v.price / 100).toFixed(2) + " " + (window.Shopify && Shopify.currency ? Shopify.currency.active : "TL");
            sizeSelect.appendChild(opt);
            if (idx === 0) {
              state.size = v.title;
              applyPosterSize(v.title);
            }
          });
          sizeSelect.addEventListener("change", function () {
            var v = p.variants.find(function (vv) { return String(vv.id) === sizeSelect.value; });
            state.size = v ? v.title : "";
            applyPosterSize(state.size);
          });
        })
        .catch(function (err) {
          setStatus("Urun bilgisi yuklenemedi: " + err.message, true);
        });
    }
    loadProduct();

    // Canvas surukleme / buyutme-kucultme (tiklanan katmani bulup onu aktif/secili yapar)
    var drag = null; // { mode: 'move'|'resize', layer, ... }

    function canvasPoint(evt) {
      var rect = canvas.getBoundingClientRect();
      var clientX = evt.touches ? evt.touches[0].clientX : evt.clientX;
      var clientY = evt.touches ? evt.touches[0].clientY : evt.clientY;
      return {
        x: ((clientX - rect.left) / rect.width) * canvas.width,
        y: ((clientY - rect.top) / rect.height) * canvas.height
      };
    }

    function findLayerBoxAt(p) {
      var boxes = root._cpLayerBoxes || [];
      for (var i = boxes.length - 1; i >= 0; i--) {
        var box = boxes[i];
        var hitR = px(HANDLE_HIT_R);
        var pad = px(BOX_PAD);
        var resizeHandle = selectionHandles(box).resize;
        var handleDist = Math.hypot(p.x - resizeHandle.x, p.y - resizeHandle.y);
        if (handleDist < hitR) return { box: box, mode: "resize" };
        var rotationRad = -((Number(box.rotation) || 0) * Math.PI) / 180;
        var dx = p.x - box.cx;
        var dy = p.y - box.cy;
        var localX = dx * Math.cos(rotationRad) - dy * Math.sin(rotationRad);
        var localY = dx * Math.sin(rotationRad) + dy * Math.cos(rotationRad);
        if (localX > -box.w / 2 - pad && localX < box.w / 2 + pad && localY > -box.h / 2 - pad && localY < box.h / 2 + pad) {
          return { box: box, mode: "move" };
        }
      }
      return null;
    }

    function onPointerDown(evt) {
      var p = canvasPoint(evt);
      var hit = findLayerBoxAt(p);
      if (!hit) return;
      var layer = state.layers.filter(function (l) { return l.id === hit.box.id; })[0];
      if (!layer) return;
      if (activeLayerId !== layer.id) {
        activeLayerId = layer.id;
        syncFormToActiveLayer();
        renderLayerList();
      }
      if (hit.mode === "resize") {
        drag = { mode: "resize", layer: layer, startDist: Math.hypot(p.x - hit.box.cx, p.y - hit.box.cy), startScale: layer.scale, cx: hit.box.cx, cy: hit.box.cy };
      } else {
        drag = { mode: "move", layer: layer, offsetX: p.x - hit.box.cx, offsetY: p.y - hit.box.cy };
      }
      evt.preventDefault();
    }

    function onPointerMove(evt) {
      if (!drag) return;
      var p = canvasPoint(evt);
      var margin = state.paspartu ? Math.round(canvas.width * 0.12) : 0;
      var innerW = canvas.width - margin * 2,
        innerH = canvas.height - margin * 2;
      if (drag.mode === "move") {
        var nx = (p.x - drag.offsetX - margin) / innerW;
        var ny = (p.y - drag.offsetY - margin) / innerH;
        drag.layer.x = Math.min(0.95, Math.max(0.05, nx));
        drag.layer.y = Math.min(0.95, Math.max(0.05, ny));
      } else if (drag.mode === "resize") {
        var dist = Math.hypot(p.x - drag.cx, p.y - drag.cy);
        var ratio = dist / Math.max(drag.startDist, 1);
        // Yazi da sekil de kullanicinin istedigi kadar buyutulebilir; tasarim tuvalden
        // tasabilir, baskiya giden alan zaten tuvalin kendisi. Sekillerdeki eski 3x siniri
        // kaldirildi: sekiller sabit 1800px kenarli rasterlerden ciziliyor (custom-poster.js
        // SVG_RASTER_LONG_EDGE) ve tuval en fazla 1500px, yani buyutmek ek bellek ayirmiyor.
        drag.layer.scale = Math.max(0.3, drag.startScale * ratio);
      }
      render();
      evt.preventDefault();
    }

    function onPointerUp() {
      drag = null;
    }

    canvas.addEventListener("mousedown", onPointerDown);
    canvas.addEventListener("touchstart", onPointerDown, { passive: false });
    window.addEventListener("mousemove", onPointerMove);
    window.addEventListener("touchmove", onPointerMove, { passive: false });
    window.addEventListener("mouseup", onPointerUp);
    window.addEventListener("touchend", onPointerUp);

    // Sepete ekle
    addBtn.addEventListener("click", function () {
      if (!product) {
        setStatus("Urun bilgisi henuz yuklenmedi, birazdan tekrar dene.", true);
        return;
      }
      var hasContent = state.layers.some(function (l) { return l.type === "shape" ? !!l.shapeUrl : l.text && l.text.trim(); });
      if (!hasContent) {
        setStatus("Lutfen once bir yazi veya sekil ekle.", true);
        return;
      }
      var variant = product.variants.find(function (v) { return String(v.id) === sizeSelect.value; });
      if (!variant) {
        setStatus("Lutfen bir boyut sec.", true);
        return;
      }

      addBtn.disabled = true;
      setStatus("Sepete ekleniyor...");

      var query = CP.encodeState(state);
      var designUrl = viewPageUrl + "?mode=view&" + query;
      var allText = state.layers
        .map(function (l) { return l.type === "shape" ? "[" + (l.shapeLabel || "sekil") + "]" : l.text; })
        .filter(Boolean)
        .join(" / ");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: variant.id,
              quantity: 1,
              properties: {
                "Arka Plan": state.bgLabel || "-",
                Yazı: allText,
                Paspartu: state.paspartu ? "Evet" : "Hayır",
                "_Tasarım Linki": designUrl
              }
            }
          ]
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "sepete eklenemedi"); });
          return r.json();
        })
        .then(function () {
          setStatus("Sepete eklendi! Sepete yonlendiriliyorsun...");
          window.location.href = "/cart";
        })
        .catch(function (err) {
          setStatus("Hata: " + err.message, true);
          addBtn.disabled = false;
        });
    });

    renderPresetCards();
    syncFormToActiveLayer();
    renderLayerList();
    render();
  });
})();
